import { Action } from 'adaptivecards';

export class OpenMailAction extends Action {
    messageId: string;

    getJsonTypeName(): string {
        return 'Action.OpenMail';
    }

    parse(json: any): void {
        super.parse(json);
        this.messageId = json.messageId;
    }
}
